import { mapState } from 'vuex';
import verifyTab from './components/verifyTab.vue';
import editPassword from './components/editPassword.vue';
import { checkAccountPassword, smsVerify, updatePasswordOrPhone } from './request';
export default {
  components: {
    verifyTab,
    editPassword
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleVerifyTab: true,
      //验证tab
      visibleEditPwd: false //修改密码
    };
  },
  computed: {
    visibleEditModal: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  mounted() {},
  methods: {
    confirmEditModal() {
      if (this.visibleVerifyTab) {
        // 第一步
        if (this.$refs.verifyRef.activeKey === '1') {
          this.$refs.verifyRef.$refs.ruleForm.validate(async valid => {
            if (valid) {
              var _this$accountInfo, _this$$refs$verifyRef;
              console.log('账号确认', this.$refs.verifyRef);
              let res = await checkAccountPassword({
                account: (_this$accountInfo = this.accountInfo) === null || _this$accountInfo === void 0 ? void 0 : _this$accountInfo.account,
                password: (_this$$refs$verifyRef = this.$refs.verifyRef.accountForm) === null || _this$$refs$verifyRef === void 0 ? void 0 : _this$$refs$verifyRef.password
              });
              if (res) {
                this.visibleVerifyTab = false;
                this.visibleEditPwd = true;
              }
            }
          });
        } else {
          this.$refs.verifyRef.$refs.mobileRuleForm.validate(async valid => {
            if (valid) {
              console.log('手机号确认', this.$refs.verifyRef);
              let res = await smsVerify({
                mobile: this.accountInfo.globalRoaming + this.accountInfo.mobile,
                code: this.$refs.verifyRef.mobileForm.code,
                way: 'updatePassword'
              });
              if (res) {
                this.visibleVerifyTab = false;
                this.visibleEditPwd = true;
              }
            }
          });
        }
      } else {
        // 修改密码
        this.$refs.editPwdRef.$refs.ruleForm.validate(async valid => {
          if (valid) {
            let res = await updatePasswordOrPhone({
              type: '1',
              //1修改密码 2修改手机号
              password: this.$refs.editPwdRef.form.password,
              password_confirmation: this.$refs.editPwdRef.form.password_confirmation
            });
            if (res) {
              // 关闭弹框
              this.visibleEditModal = false;
              // this.visibleVerifyTab = false;
              // this.visibleEditPwd = false;
              this.$message.success(this.$t('密码设置成功，请重新登录'));
              // 退出登录
              await this.$store.dispatch('user/logout');
              clearInterval();
              await this.$store.dispatch('tagsView/clearTag');
              console.log('this.$router', this.$router);
              this.$router.replace({
                path: '/login'
              });
              sessionStorage.removeItem('loginTime');
              sessionStorage.removeItem('loginRandomId');
            }
          }
        });
      }
    },
    cancleEditModal() {
      var _this$$refs;
      console.log('cancleEditModal', (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.verifyRef);
      this.visibleEditModal = false;
      // this.$emit('update:visible', false); //密码安全校验弹框关闭
      this.visibleVerifyTab = true;
      this.visibleEditPwd = false;
      this.$refs.verifyRef.activeKey = '';
    }
  }
};